import { defineChain } from 'viem';

export const cratD2Ctestnet = defineChain({
  id: 65349,
  name: 'CratD2C Testnet',
  testnet: true,
  nativeCurrency: {
    decimals: 18,
    name: 'CRAT',
    symbol: 'CRAT',
  },
  rpcUrls: {
    public: { http: ['https://cratd2c-testnet-node1.cratd2csmartchain.io'] },
    default: { http: ['https://cratd2c-testnet-node1.cratd2csmartchain.io'] },
  },
  blockExplorers: {
    default: {
      name: 'CratD2C Explorer',
      url: 'https://explorer-testnet.cratd2csmartchain.io',
    },
  },
});

export const cratD2CMainnet = defineChain({
  id: 2310,
  name: 'CratD2C',
  nativeCurrency: {
    decimals: 18,
    name: 'CRAT',
    symbol: 'CRAT',
  },
  rpcUrls: {
    public: { http: ['https://node2.cratd2csmartchain.io'] },
    default: { http: ['https://node1.cratd2csmartchain.io', 'https://node3.cratd2csmartchain.io'] },
  },
  blockExplorers: {
    default: {
      name: 'CratD2C Explorer',
      url: 'https://explorer.cratd2csmartchain.io',
    },
  },
});
